module.exports = __webpack_public_path__ + "static/media/craig_yu_chun_yang.812811e6.jpg";